import {useEffect, useState} from "react";
import { Card } from "../../../components/card/card.jsx";
import { Template } from "../../../components/template/template.jsx";
import CalendarComponent from "./components/CalendarComponent.jsx";
import CalendarModal from "./components/CalendarModal.jsx";

export default function ScheduleAttendanceCalendar() {
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState({ title: null, body: null });

    const openModal = (data) => {
    setModalData(data);
    setShowModal(true);
    };

    const closeModal = () => {
    setShowModal(false);
    setModalData({ title: null, body: null });
    };

    return (
        <Template>
            <Template.Header>
                <Template.Title>Calendário de agendamento</Template.Title>
            </Template.Header>
            <Template.Body>
                <Card>
                    <Card.Body className="flex">
                        <div className="h-[calc(100vh-91px)] w-full">
                            <CalendarComponent openModal={openModal} />
                        </div>
                        <CalendarModal show={showModal} onClose={closeModal} title={modalData.title}>
                            {modalData.body}
                        </CalendarModal>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    )
};